const WorkoutData = [
    {
        bodyPart: "waist",
        equipment: "body weight",
        gifUrl: "./images/exercise/4 sit up.mp4",
        id: 1,
        name: "3/4 sit-up",
        target: "abs",
        secondaryMuscles: ["hip flexors", "lower back"],
        instructions: [
            "Lie flat on your back with your knees bent and feet flat on the ground.",
            "Place your hands behind your head with your elbows pointing outwards.",
            "Engaging your abs, slowly lift your upper body off the ground, curling forward until your torso is at a 45-degree angle.",
            "Pause for a moment at the top, then slowly lower your upper body back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "waist",
        equipment: "body weight",
        gifUrl: "./images/exercise/45 degree side bend.mp4",
        id: 2,
        name: "45° side bend",
        target: "abs",
        secondaryMuscles: ["obliques"],
        instructions: [
            "Stand with your feet shoulder-width apart and your arms extended straight down by your sides.",
            "Keeping your back straight and your core engaged, slowly bend your torso to one side, lowering your hand towards your knee.",
            "Pause for a moment at the bottom, then slowly return to the starting position.",
            "Repeat on the other side.",
            "Continue alternating sides for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "waist",
        equipment: "body weight",
        gifUrl: "./images/exercise/air bike.mp4",
        id: 3,
        name: "air bike",
        target: "abs",
        secondaryMuscles: ["hip flexors"],
        instructions: [
            "Lie flat on your back with your hands placed behind your head.",
            "Lift your legs off the ground and bend your knees at a 90-degree angle.",
            "Bring your right elbow towards your left knee while simultaneously straightening your right leg.",
            "Return to the starting position and repeat the movement on the opposite side, bringing your left elbow towards your right knee while straightening your left leg.",
            "Continue alternating sides in a pedaling motion for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "waist",
        equipment: "body weight",
        gifUrl: "./images/exercise/alternate heel touchers.mp4",
        id: 4,
        name: "alternate heel touchers",
        target: "abs",
        secondaryMuscles: ["obliques"],
        instructions: [
            "Lie flat on your back with your knees bent and feet flat on the ground.",
            "Extend your arms straight out to the sides, parallel to the ground.",
            "Engaging your abs, lift your shoulders off the ground and reach your right hand towards your right heel.",
            "Return to the starting position and repeat on the left side, reaching your left hand towards your left heel.",
            "Continue alternating sides for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "waist",
        equipment: "assisted",
        gifUrl: "./images/exercise/assisted hanging knee raise with throw down.mp4",
        id: 5,
        name: "assisted hanging knee raise with throw down",
        target: "abs",
        secondaryMuscles: ["hip flexors", "lower back"],
        instructions: [
            "Hang from a pull-up bar with your arms fully extended and your palms facing away from you.",
            "Engage your core and lift your knees towards your chest, keeping your legs together.",
            "Once your knees are at chest level, explosively throw your legs down towards the ground, extending them fully.",
            "Allow your legs to swing back up and repeat the movement for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "waist",
        equipment: "assisted",
        gifUrl: "./images/exercise/assisted hanging knee raise.mp4",
        id: 6,
        name: "assisted hanging knee raise",
        target: "abs",
        secondaryMuscles: ["hip flexors"],
        instructions: [
            "Hang from a pull-up bar with your arms fully extended and your palms facing away from you.",
            "Engage your core muscles and lift your knees towards your chest, bending at the hips and knees.",
            "Pause for a moment at the top of the movement, squeezing your abs.",
            "Slowly lower your legs back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "waist",
        equipment: "assisted",
        gifUrl: "./images/exercise/assisted lying leg raise with lateral throw down.mp4",
        id: 7,
        name: "assisted lying leg raise with lateral throw down",
        target: "abs",
        secondaryMuscles: ["hip flexors", "obliques"],
        instructions: [
            "Lie flat on your back with your legs extended and your arms by your sides.",
            "Place your hands under your glutes for support.",
            "Engage your abs and lift your legs off the ground, keeping them straight.",
            "While keeping your legs together, lower them to one side until they are a few inches above the ground.",
            "Pause for a moment, then lift your legs back to the starting position.",
            "Repeat the movement to the other side.",
            "Continue alternating sides for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "waist",
        equipment: "assisted",
        gifUrl: "./images/exercise/assisted lying leg raise with throw down.mp4",
        id: 8,
        name: "assisted lying leg raise with throw down",
        target: "abs",
        secondaryMuscles: ["hip flexors", "quadriceps"],
        instructions: [
            "Lie flat on your back with your legs extended and your arms by your sides.",
            "Place your hands under your glutes for support.",
            "Engage your core and lift your legs off the ground, keeping them straight.",
            "Raise your legs until they are perpendicular to the ground.",
            "Lower your legs back down to the starting position.",
            "Simultaneously, throw your legs down towards the ground, keeping them straight.",
            "Raise your legs back up to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "back",
        equipment: "cable",
        gifUrl: "./images/exercise/alternate lateral pulldown.mp4",
        id: 9,
        name: "alternate lateral pulldown",
        target: "lats",
        secondaryMuscles: ["biceps", "rhomboids"],
        instructions: [
            "Sit on the cable machine with your back straight and feet flat on the ground.",
            "Grasp the handles with an overhand grip, slightly wider than shoulder-width apart.",
            "Lean back slightly and pull the handles towards your chest, squeezing your shoulder blades together.",
            "Pause for a moment at the peak of the movement, then slowly release the handles back to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "back",
        equipment: "leverage machine",
        gifUrl: "./images/exercise/assisted parallel close grip pull-up.gif",
        id: 10,
        name: "assisted parallel close grip pull-up",
        target: "lats",
        secondaryMuscles: ["biceps", "forearms"],
        instructions: [
            "Adjust the machine to your desired weight and height.",
            "Place your hands on the parallel bars with a close grip, palms facing each other.",
            "Hang from the bars with your arms fully extended and your feet off the ground.",
            "Engage your back muscles and pull your body up towards the bars, keeping your elbows close to your body.",
            "Continue pulling until your chin is above the bars.",
            "Pause for a moment at the top, then slowly lower your body back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "back",
        equipment: "leverage machine",
        gifUrl: "./images/exercise/assisted pull-up.gif",
        id: 11,
        name: "assisted pull-up",
        target: "lats",
        secondaryMuscles: ["biceps", "forearms"],
        instructions: [
            "Adjust the machine to your desired weight and height settings.",
            "Grasp the handles with an overhand grip, slightly wider than shoulder-width apart.",
            "Hang with your arms fully extended and your feet off the ground.",
            "Engage your back muscles and pull your body up towards the handles, keeping your elbows close to your body.",
            "Continue pulling until your chin is above the handles.",
            "Pause for a moment at the top, then slowly lower your body back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "back",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell pullover to press.mp4",
        id: 12,
        name: "barbell pullover to press",
        target: "lats",
        secondaryMuscles: ["triceps", "chest", "shoulders"],
        instructions: [
            "Lie flat on a bench with your head at one end and your feet on the ground.",
            "Hold the barbell with a pronated grip (palms facing away from you) and extend your arms straight above your chest.",
            "Keeping your arms straight, lower the barbell behind your head in an arc-like motion until you feel a stretch in your lats.",
            "Pause for a moment, then reverse the motion and press the barbell back to the starting position above your chest.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "back",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell bent over row.mp4",
        id: 13,
        name: "barbell bent over row",
        target: "upper back",
        secondaryMuscles: ["biceps", "forearms"],
        instructions: [
            "Stand with your feet shoulder-width apart and knees slightly bent.",
            "Bend forward at the hips while keeping your back straight and chest up.",
            "Grasp the barbell with an overhand grip, hands slightly wider than shoulder-width apart.",
            "Pull the barbell towards your lower chest by retracting your shoulder blades and squeezing your back muscles.",
            "Pause for a moment at the top, then slowly lower the barbell back to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "back",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell decline bent arm pullover.mp4",
        id: 14,
        name: "barbell decline bent arm pullover",
        target: "lats",
        secondaryMuscles: ["triceps", "chest"],
        instructions: [
            "Lie down on a decline bench with your head lower than your hips and your feet secured.",
            "Hold a barbell with a pronated grip (palms facing away from you) and extend your arms straight above your chest.",
            "Lower the barbell behind your head in a controlled manner, keeping your arms slightly bent.",
            "Pause for a moment, then raise the barbell back to the starting position by contracting your lats.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "back",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell decline wide-grip pullover.mp4",
        id: 15,
        name: "barbell decline wide-grip pullover",
        target: "lats",
        secondaryMuscles: ["triceps", "chest"],
        instructions: [
            "Lie on a decline bench with your head lower than your hips and your feet secured.",
            "Hold a barbell with a wide grip and extend your arms straight above your chest.",
            "Lower the barbell behind your head in a controlled manner, keeping your arms straight.",
            "Pause for a moment, then raise the barbell back to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "back",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell incline row.mp4",
        id: 16,
        name: "barbell incline row",
        target: "upper back",
        secondaryMuscles: ["biceps", "forearms"],
        instructions: [
            "Set up an incline bench at a 45-degree angle.",
            "Lie face down on the bench with your chest against the pad and your feet flat on the ground.",
            "Grasp the barbell with an overhand grip, slightly wider than shoulder-width apart.",
            "Keep your back straight and your core engaged.",
            "Pull the barbell towards your chest, squeezing your shoulder blades together.",
            "Pause for a moment at the top, then slowly lower the barbell back to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "back",
        equipment: "Dumbell",
        gifUrl: "./images/exercise/Dumbell arm bent over row.mp4",
        id: 17,
        name: "Dumbell arm bent over row",
        target: "upper back",
        secondaryMuscles: ["biceps", "forearms"],
        instructions: [
            "Stand with your feet shoulder-width apart, knees slightly bent, and hold a barbell with one hand using an overhand grip.",
            "Bend forward at the hips, keeping your back straight and your head in a neutral position.",
            "Pull the barbell up towards your chest, keeping your elbow close to your body and squeezing your shoulder blades together.",
            "Lower the barbell back down to the starting position in a controlled manner.",
            "Repeat for the desired number of repetitions, then switch to the other arm.",
        ],
    },
    {
        bodyPart: "cardio",
        equipment: "body weight",
        gifUrl: "./images/exercise/jack burpee.mp4",
        id: 18,
        name: "jack burpee",
        target: "cardiovascular system",
        secondaryMuscles: [
            "quadriceps",
            "hamstrings",
            "calves",
            "shoulders",
            "triceps",
            "core",
        ],
        instructions: [
            "Start in a standing position with your feet shoulder-width apart.",
            "Lower your body into a squat position, placing your hands on the ground in front of you.",
            "Kick your feet back, landing in a push-up position.",
            "Perform a push-up, lowering your chest to the ground and then pushing back up.",
            "Jump your feet forward, landing in a squat position.",
            "Jump up explosively, reaching your arms overhead.",
            "Land softly and immediately lower back into the squat position to begin the next repetition.",
        ],
    },
    {
        bodyPart: "cardio",
        equipment: "body weight",
        gifUrl: "./images/exercise/mountain climber.mp4",
        id: 19,
        name: "mountain climber",
        target: "cardiovascular system",
        secondaryMuscles: ["core", "shoulders", "triceps"],
        instructions: [
            "Start in a high plank position with your hands directly under your shoulders and your body in a straight line.",
            "Engage your core and bring your right knee towards your chest, then quickly switch and bring your left knee towards your chest.",
            "Continue alternating legs in a running motion, keeping your hips low and your core engaged.",
            "Maintain a steady pace and breathe evenly throughout the exercise.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "cardio",
        equipment: "body weight",
        gifUrl: "./images/exercise/run (equipment).mp4",
        id: 20,
        name: "run (equipment)",
        target: "cardiovascular system",
        secondaryMuscles: ["quadriceps", "hamstrings", "calves"],
        instructions: [
            "Start by standing upright with your feet hip-width apart.",
            "Engage your core and keep your upper body relaxed.",
            "Begin jogging in place, lifting your knees up towards your chest and landing softly on the balls of your feet.",
            "Maintain a steady pace and continue jogging for the desired duration or distance.",
            "Remember to breathe deeply and maintain good posture throughout the exercise.",
        ],
    },
    {
        bodyPart: "cardio",
        equipment: "body weight",
        gifUrl: "./images/exercise/run.mp4",
        id: 21,
        name: "run",
        target: "cardiovascular system",
        secondaryMuscles: ["quadriceps", "hamstrings", "calves"],
        instructions: [
            "Start by standing upright with your feet hip-width apart.",
            "Engage your core and keep your upper body relaxed.",
            "Begin jogging in place, lifting your knees up towards your chest and landing softly on the balls of your feet.",
            "Maintain a steady pace and continue jogging for the desired duration or distance.",
            "Remember to breathe deeply and maintain good posture throughout the exercise.",
        ],
    },
    {
        bodyPart: "cardio",
        equipment: "leverage machine",
        gifUrl: "./images/exercise/stationary bike walk.mp4",
        id: 22,
        name: "stationary bike walk",
        target: "cardiovascular system",
        secondaryMuscles: ["quadriceps", "hamstrings", "calves"],
        instructions: [
            "Adjust the seat height and position on the stationary bike to ensure proper alignment.",
            "Place your feet on the pedals and secure them with the straps if available.",
            "Start pedaling at a comfortable pace, keeping your back straight and core engaged.",
            "Maintain a steady rhythm and increase the resistance level if desired.",
            "Continue pedaling for the desired duration of your cardio workout.",
            "Cool down by gradually reducing your pace and resistance level.",
            "Stretch your leg muscles after the workout to prevent tightness and promote recovery.",
        ],
    },
    {
        bodyPart: "cardio",
        equipment: "body weight",
        gifUrl: "./images/exercise/burpee.mp4",
        id: 23,
        name: "burpee",
        target: "cardiovascular system",
        secondaryMuscles: [
            "quadriceps",
            "hamstrings",
            "calves",
            "shoulders",
            "chest",
        ],
        instructions: [
            "Start in a standing position with your feet shoulder-width apart.",
            "Lower your body into a squat position by bending your knees and placing your hands on the floor in front of you.",
            "Kick your feet back into a push-up position.",
            "Perform a push-up, keeping your body in a straight line.",
            "Jump your feet back into the squat position.",
            "Jump up explosively, reaching your arms overhead.",
            "Land softly and immediately lower back into a squat position to begin the next repetition.",
        ],
    },
    {
        bodyPart: "cardio",
        equipment: "dumbbell",
        gifUrl: "./images/exercise/dumbbell burpee.mp4",
        id: 24,
        name: "dumbbell burpee",
        target: "cardiovascular system",
        secondaryMuscles: [
            "quadriceps",
            "hamstrings",
            "calves",
            "shoulders",
            "triceps",
            "core",
        ],
        instructions: [
            "Start in a standing position with your feet shoulder-width apart and a dumbbell in each hand.",
            "Lower your body into a squat position, placing the dumbbells on the ground in front of you.",
            "Kick your feet back into a push-up position, keeping your body in a straight line.",
            "Perform a push-up, bending your elbows and lowering your chest towards the ground.",
            "Jump your feet back towards your hands, landing in a squat position.",
            "Stand up explosively, lifting the dumbbells off the ground and bringing them to your shoulders.",
            "Press the dumbbells overhead, fully extending your arms.",
            "Lower the dumbbells back to your shoulders and repeat the entire sequence for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "cardio",
        equipment: "stationary bike",
        gifUrl: "./images/exercise/stationary bike run v. 3.mp4",
        id: 25,
        name: "stationary bike run v. 3",
        target: "cardiovascular system",
        secondaryMuscles: ["quadriceps", "hamstrings", "calves"],
        instructions: [
            "Adjust the seat height and position to ensure proper alignment.",
            "Place your feet on the pedals and secure them with the straps if available.",
            "Start pedaling at a comfortable pace.",
            "Maintain a steady rhythm and increase the resistance as desired.",
            "Engage your core muscles to maintain stability and proper posture.",
            "Continue pedaling for the desired duration of your workout.",
            "Gradually decrease the resistance and slow down before coming to a complete stop.",
            "Stretch your legs and cool down after the workout.",
        ],
    },
    {
        bodyPart: "cardio",
        equipment: "elliptical machine",
        gifUrl: "./images/exercise/walk elliptical cross trainer.mp4",
        id: 26,
        name: "walk elliptical cross trainer",
        target: "cardiovascular system",
        secondaryMuscles: ["quadriceps", "hamstrings", "glutes", "calves"],
        instructions: [
            "Adjust the resistance level and incline of the elliptical machine to your desired settings.",
            "Step onto the pedals of the machine and grip the handles lightly.",
            "Begin by pushing down with your feet and pulling the handles towards your body.",
            "Continue this motion, alternating between pushing and pulling, to simulate a walking or running motion.",
            "Maintain a steady pace and keep your core engaged throughout the exercise.",
            "Continue for the desired duration of your cardio workout.",
            "Gradually decrease the intensity and speed of the machine before stepping off.",
        ],
    },
    {
        bodyPart: "cardio",
        equipment: "stepmill machine",
        gifUrl: "./images/exercise/walking on stepmill.mp4",
        id: 27,
        name: "walking on stepmill",
        target: "cardiovascular system",
        secondaryMuscles: ["quadriceps", "hamstrings", "glutes", "calves"],
        instructions: [
            "Adjust the stepmill machine to a comfortable level.",
            "Step onto the machine and place your hands on the handrails for support.",
            "Start walking by placing one foot on a step and then the other, alternating between legs.",
            "Maintain an upright posture and engage your core muscles.",
            "Continue walking for the desired duration or distance.",
            "Gradually increase the intensity or speed as you become more comfortable with the exercise.",
            "Remember to cool down and stretch after completing the exercise.",
        ],
    },
    {
        bodyPart: "chest",
        equipment: "leverage machine",
        gifUrl: "./images/exercise/assisted chest dip (kneeling).mp4",
        id: 28,
        name: "assisted chest dip (kneeling)",
        target: "pectorals",
        secondaryMuscles: ["triceps", "shoulders"],
        instructions: [
            "Adjust the machine to your desired height and secure your knees on the pad.",
            "Grasp the handles with your palms facing down and your arms fully extended.",
            "Lower your body by bending your elbows until your upper arms are parallel to the floor.",
            "Pause for a moment, then push yourself back up to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "chest",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell bench press.mp4",
        id: 29,
        name: "barbell bench press",
        target: "pectorals",
        secondaryMuscles: ["triceps", "shoulders"],
        instructions: [
            "Lie flat on a bench with your feet flat on the ground and your back pressed against the bench.",
            "Grasp the barbell with an overhand grip slightly wider than shoulder-width apart.",
            "Lift the barbell off the rack and hold it directly above your chest with your arms fully extended.",
            "Lower the barbell slowly towards your chest, keeping your elbows tucked in.",
            "Pause for a moment when the barbell touches your chest.",
            "Push the barbell back up to the starting position by extending your arms.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "chest",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell decline bench press.mp4",
        id: 30,
        name: "barbell decline bench press",
        target: "pectorals",
        secondaryMuscles: ["triceps", "shoulders"],
        instructions: [
            "Lie on a decline bench with your feet secured and your head lower than your hips.",
            "Grasp the barbell with an overhand grip slightly wider than shoulder-width apart.",
            "Unrack the barbell and lower it slowly towards your chest, keeping your elbows tucked in.",
            "Pause for a moment at the bottom, then push the barbell back up to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "chest",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell decline wide-grip press.mp4",
        id: 31,
        name: "barbell decline wide-grip press",
        target: "pectorals",
        secondaryMuscles: ["triceps", "shoulders"],
        instructions: [
            "Lie on a decline bench with your feet secured and your head lower than your hips.",
            "Grasp the barbell with a wide grip, slightly wider than shoulder-width apart.",
            "Lower the barbell to your chest, keeping your elbows out to the sides.",
            "Push the barbell back up to the starting position, fully extending your arms.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "chest",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell front raise and pullover.mp4",
        id: 32,
        name: "barbell front raise and pullover",
        target: "pectorals",
        secondaryMuscles: ["deltoids", "triceps"],
        instructions: [
            "Stand with your feet shoulder-width apart and hold a barbell with an overhand grip, palms facing down.",
            "Keep your arms straight and raise the barbell in front of you until it reaches shoulder height.",
            "Pause for a moment at the top, then slowly lower the barbell back down to the starting position.",
            "Next, lower the barbell behind your head, keeping your arms straight.",
            "Pause for a moment at the bottom, then raise the barbell back up to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "chest",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell guillotine bench press.mp4",
        id: 33,
        name: "barbell guillotine bench press",
        target: "pectorals",
        secondaryMuscles: ["shoulders", "triceps"],
        instructions: [
            "Lie flat on a bench with your feet flat on the ground and your back pressed against the bench.",
            "Grasp the barbell with an overhand grip, slightly wider than shoulder-width apart.",
            "Lower the barbell slowly towards your neck, keeping your elbows pointed outwards.",
            "Pause for a moment when the barbell is just above your neck.",
            "Push the barbell back up to the starting position, fully extending your arms.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "chest",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell incline bench press.mp4",
        id: 34,
        name: "barbell incline bench press",
        target: "pectorals",
        secondaryMuscles: ["shoulders", "triceps"],
        instructions: [
            "Set up an incline bench at a 45-degree angle.",
            "Lie down on the bench with your feet flat on the ground.",
            "Grasp the barbell with an overhand grip, slightly wider than shoulder-width apart.",
            "Unrack the barbell and lower it slowly towards your chest, keeping your elbows at a 45-degree angle.",
            "Pause for a moment at the bottom, then push the barbell back up to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "chest",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell incline shoulder raise.mp4",
        id: 35,
        name: "barbell incline shoulder raise",
        target: "serratus anterior",
        secondaryMuscles: ["deltoids", "trapezius"],
        instructions: [
            "Set up an incline bench at a 45-degree angle.",
            "Sit on the bench with your back against the pad and feet flat on the ground.",
            "Hold a barbell with an overhand grip, slightly wider than shoulder-width apart.",
            "Lift the barbell up to shoulder height, keeping your elbows slightly bent.",
            "Slowly raise the barbell overhead, extending your arms fully.",
            "Pause for a moment at the top, then slowly lower the barbell back to shoulder height.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "chest",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell wide bench press.mp4",
        id: 36,
        name: "barbell wide bench press",
        target: "pectorals",
        secondaryMuscles: ["shoulders", "triceps"],
        instructions: [
            "Lie flat on a bench with your feet flat on the ground and your back pressed against the bench.",
            "Grasp the barbell with a wide grip, slightly wider than shoulder-width apart.",
            "Lift the barbell off the rack and hold it directly above your chest with your arms fully extended.",
            "Lower the barbell slowly towards your chest, keeping your elbows slightly flared out.",
            "Pause for a moment when the barbell touches your chest, then push it back up to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "chest",
        equipment: "cable",
        gifUrl: "./images/exercise/cable bench press.mp4",
        id: 37,
        name: "cable bench press",
        target: "pectorals",
        secondaryMuscles: ["triceps", "shoulders"],
        instructions: [
            "Adjust the cable machine to chest height and attach the handles.",
            "Stand facing away from the machine with your feet shoulder-width apart.",
            "Grasp the handles with an overhand grip and step forward to create tension in the cables.",
            "Position your feet firmly on the ground and engage your core.",
            "Bend your elbows and bring your hands to shoulder level, keeping your elbows at a 90-degree angle.",
            "Push the handles forward, extending your arms fully in front of you.",
            "Pause for a moment, then slowly reverse the movement, bringing your hands back to shoulder level.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower arms",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell revers wrist curl v. 2.mp4",
        id: 38,
        name: "barbell revers wrist curl v. 2",
        target: "forearms",
        secondaryMuscles: ["biceps", "brachialis"],
        instructions: [
            "Sit on a bench with your feet flat on the ground and your knees bent.",
            "Hold a barbell with an overhand grip, palms facing down, and your hands shoulder-width apart.",
            "Rest your forearms on your thighs, allowing your wrists to hang off the edge.",
            "Keeping your forearms stationary, exhale and curl your wrists upward as far as possible.",
            "Hold the contracted position for a brief pause, then inhale and slowly lower the barbell back to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower arms",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell reverse wrist curl.mp4",
        id: 39,
        name: "barbell reverse wrist curl",
        target: "forearms",
        secondaryMuscles: ["biceps", "brachialis"],
        instructions: [
            "Sit on a bench with your feet flat on the ground and hold a barbell with an overhand grip, palms facing down.",
            "Rest your forearms on your thighs, allowing your wrists to hang off the edge.",
            "Slowly curl your wrists upward, bringing the barbell towards your body.",
            "Pause for a moment at the top, then slowly lower the barbell back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower arms",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell standing back wrist curl.mp4",
        id: 40,
        name: "barbell standing back wrist curl",
        target: "forearms",
        secondaryMuscles: ["biceps", "shoulders"],
        instructions: [
            "Stand up straight with your feet shoulder-width apart and hold a barbell with an overhand grip.",
            "Rest the barbell on the back of your hands with your palms facing down and your fingers pointing towards your body.",
            "Keeping your upper arms stationary, exhale and curl your wrists upwards as far as possible.",
            "Hold the contracted position for a brief pause, then inhale and slowly lower the barbell back to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower arms",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell wrist curl v. 2.mp4",
        id: 41,
        name: "barbell wrist curl v. 2",
        target: "forearms",
        secondaryMuscles: ["biceps", "brachialis"],
        instructions: [
            "Sit on a bench with your feet flat on the ground and your knees bent.",
            "Hold a barbell with an underhand grip, palms facing up, and your hands shoulder-width apart.",
            "Rest your forearms on your thighs, allowing your wrists to hang off the edge.",
            "Slowly curl your wrists upward, bringing the barbell towards your forearms.",
            "Pause for a moment at the top, then slowly lower the barbell back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower arms",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell wrist curl.mp4",
        id: 42,
        name: "barbell wrist curl",
        target: "forearms",
        secondaryMuscles: ["biceps", "brachialis"],
        instructions: [
            "Sit on a bench with your feet flat on the ground and your forearms resting on your thighs, holding a barbell with an underhand grip.",
            "Allow the barbell to roll down to your fingertips, keeping your wrists straight.",
            "Slowly curl the barbell up towards your forearms by flexing your wrists.",
            "Pause for a moment at the top, then slowly lower the barbell back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower arms",
        equipment: "cable",
        gifUrl: "./images/exercise/cable reverse wrist curl.mp4",
        id: 43,
        name: "cable reverse wrist curl",
        target: "forearms",
        secondaryMuscles: ["forearms", "wrists"],
        instructions: [
            "Attach a cable to a low pulley and sit on a bench facing the cable machine.",
            "Grasp the cable handle with an overhand grip, palms facing down.",
            "Rest your forearms on your thighs, with your wrists hanging off the edge.",
            "Keeping your forearms stationary, exhale and curl your wrists upward as far as possible.",
            "Pause for a moment at the top, then inhale and slowly lower your wrists back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower arms",
        equipment: "cable",
        gifUrl: "./images/exercise/cable standing back wrist curl.mp4",
        id: 44,
        name: "cable standing back wrist curl",
        target: "forearms",
        secondaryMuscles: ["biceps", "brachialis"],
        instructions: [
            "Stand facing a cable machine with your feet shoulder-width apart.",
            "Hold the cable handle with an overhand grip, palms facing down.",
            "Keep your arms straight and your elbows close to your sides.",
            "Slowly curl your wrists upward, bringing the cable handle towards your body.",
            "Pause for a moment at the top, then slowly lower the cable handle back to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower arms",
        equipment: "cable",
        gifUrl: "./images/exercise/cable wrist curl.mp4",
        id: 45,
        name: "cable wrist curl",
        target: "forearms",
        secondaryMuscles: ["biceps", "brachialis"],
        instructions: [
            "Attach a straight bar to a low pulley cable machine.",
            "Stand facing the machine with your feet shoulder-width apart.",
            "Grasp the bar with an underhand grip, palms facing up, and your hands shoulder-width apart.",
            "Rest your forearms on a bench or pad, with your wrists hanging off the edge.",
            "Keeping your forearms stationary, exhale and curl your wrists upward as far as possible.",
            "Pause for a moment at the top, then inhale and slowly lower the bar back to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower arms",
        equipment: "dumbbell",
        gifUrl: "./images/exercise/dumbbell lying pronation.mp4",
        id: 46,
        name: "dumbbell lying pronation",
        target: "forearms",
        secondaryMuscles: ["biceps", "shoulders"],
        instructions: [
            "Lie flat on a bench with your chest facing down and your arms extended straight down, holding a dumbbell in each hand.",
            "Rotate your palms so they are facing up.",
            "Keeping your upper arms stationary, exhale and curl the dumbbells as you rotate your palms to face down.",
            "Inhale and slowly lower the dumbbells back to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower arms",
        equipment: "dumbbell",
        gifUrl: "./images/exercise/dumbbell lying supination.mp4",
        id: 47,
        name: "dumbbell lying supination",
        target: "forearms",
        secondaryMuscles: ["biceps", "shoulders"],
        instructions: [
            "Lie flat on a bench with your feet flat on the ground.",
            "Hold a dumbbell in each hand with your palms facing up and your arms fully extended.",
            "Keeping your upper arms stationary, curl the dumbbells towards your shoulders by contracting your forearms.",
            "Pause for a moment at the top, then slowly lower the dumbbells back to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower legs",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell seated calf raise.mp4",
        id: 48,
        name: "barbell seated calf raise",
        target: "calves",
        secondaryMuscles: ["hamstrings", "quadriceps"],
        instructions: [
            "Sit on a bench with your feet flat on the floor and a barbell resting on your thighs.",
            "Place the balls of your feet on a raised platform, such as a block or step.",
            "Position the barbell across your thighs and hold it securely with your hands.",
            "Keeping your back straight and your core engaged, lift your heels off the ground by extending your ankles.",
            "Pause for a moment at the top, then slowly lower your heels back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower legs",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell standing leg calf raise.mp4",
        id: 49,
        name: "barbell standing leg calf raise",
        target: "calves",
        secondaryMuscles: ["hamstrings", "glutes"],
        instructions: [
            "Stand with your feet shoulder-width apart and place a barbell across your upper back.",
            "Raise your heels off the ground as high as possible, using your calves.",
            "Pause for a moment at the top, then slowly lower your heels back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower legs",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell standing rocking leg calf raise.mp4",
        id: 50,
        name: "barbell standing rocking leg calf raise",
        target: "calves",
        secondaryMuscles: ["hamstrings", "quadriceps"],
        instructions: [
            "Stand with your feet shoulder-width apart and hold a barbell across your upper back.",
            "Raise your heels off the ground as high as possible, balancing on the balls of your feet.",
            "Slowly lower your heels back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower legs",
        equipment: "body weight",
        gifUrl: "./images/exercise/circles knee stretch.mp4",
        id: 51,
        name: "circles knee stretch",
        target: "calves",
        secondaryMuscles: ["hamstrings", "quadriceps"],
        instructions: [
            "Stand with your feet shoulder-width apart and your hands on your hips.",
            "Bend your knees slightly and lift your heels off the ground, balancing on the balls of your feet.",
            "Keeping your knees bent, rotate your knees in a circular motion, first clockwise and then counterclockwise.",
            "Perform the movement for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower legs",
        equipment: "body weight",
        gifUrl: "./images/exercise/donkey calf raise.mp4",
        id: 52,
        name: "donkey calf raise",
        target: "calves",
        secondaryMuscles: ["hamstrings", "glutes"],
        instructions: [
            "Stand with your toes on an elevated surface, such as a step or block.",
            "Place your hands on a stable support, such as a wall or railing, for balance.",
            "Raise your heels as high as possible, lifting your body weight onto the balls of your feet.",
            "Pause for a moment at the top, then slowly lower your heels back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower legs",
        equipment: "dumbbell",
        gifUrl: "./images/exercise/dumbbell seated one leg calf raise.mp4",
        id: 53,
        name: "dumbbell seated one leg calf raise",
        target: "calves",
        secondaryMuscles: ["hamstrings", "glutes"],
        instructions: [
            "Sit on a bench or chair with your feet flat on the ground and a dumbbell resting on your right thigh.",
            "Extend your left leg straight out in front of you, keeping your foot flexed.",
            "Place the ball of your right foot on an elevated surface, such as a step or weight plate.",
            "Using your calf muscles, raise your right heel as high as possible.",
            "Pause for a moment at the top, then slowly lower your heel back down to the starting position.",
            "Repeat for the desired number of repetitions, then switch legs.",
        ],
    },
    {
        bodyPart: "lower legs",
        equipment: "dumbbell",
        gifUrl: "./images/exercise/dumbbell single leg calf raise.mp4",
        id: 54,
        name: "dumbbell single leg calf raise",
        target: "calves",
        secondaryMuscles: ["ankles"],
        instructions: [
            "Stand on the edge of a step or platform with your heels hanging off and your toes on the step.",
            "Hold a dumbbell in one hand and place your other hand on a wall or railing for support.",
            "Raise your heel as high as possible, lifting your body up onto your toes.",
            "Pause for a moment at the top, then slowly lower your heel back down below the step.",
            "Repeat for the desired number of repetitions, then switch to the other leg.",
        ],
    },
    {
        bodyPart: "lower legs",
        equipment: "dumbbell",
        gifUrl: "./images/exercise/dumbbell standing calf raise.gif",
        id: 55,
        name: "dumbbell standing calf raise",
        target: "calves",
        secondaryMuscles: ["ankles"],
        instructions: [
            "Stand with your feet shoulder-width apart, holding a dumbbell in each hand.",
            "Raise your heels off the ground as high as possible, using your calves.",
            "Pause for a moment at the top, then slowly lower your heels back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower legs",
        equipment: "leverage machine",
        gifUrl: "./images/exercise/lever seated calf raise.mp4",
        id: 56,
        name: "lever seated calf raise",
        target: "calves",
        secondaryMuscles: ["soleus", "ankle stabilizers"],
        instructions: [
            "Adjust the seat height so that your knees are slightly bent and your feet are flat on the footplate.",
            "Place your toes on the footplate with your heels hanging off the edge.",
            "Grasp the handles or the sides of the seat for stability.",
            "Push through the balls of your feet to raise your heels as high as possible.",
            "Pause for a moment at the top, then slowly lower your heels back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "lower legs",
        equipment: "leverage machine",
        gifUrl: "./images/exercise/lever standing calf raise.mp4",
        id: 57,
        name: "lever standing calf raise",
        target: "calves",
        secondaryMuscles: ["soleus", "ankle stabilizers"],
        instructions: [
            "Adjust the machine to your height and stand with your feet shoulder-width apart.",
            "Place your shoulders under the pads and hold onto the handles for stability.",
            "Raise your heels as high as possible by extending your ankles.",
            "Pause for a moment at the top, then slowly lower your heels back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "shoulders",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell front raise.mp4",
        id: 58,
        name: "barbell front raise",
        target: "delts",
        secondaryMuscles: ["biceps", "triceps"],
        instructions: [
            "Stand with your feet shoulder-width apart and hold a barbell in front of your thighs with an overhand grip.",
            "Keep your arms straight and lift the barbell forward and upward until it reaches shoulder level.",
            "Pause for a moment at the top, then slowly lower the barbell back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "shoulders",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell one arm snatch.mp4",
        id: 59,
        name: "barbell one arm snatch",
        target: "delts",
        secondaryMuscles: ["traps", "forearms", "core"],
        instructions: [
            "Stand with your feet shoulder-width apart, toes pointing slightly outwards.",
            "Hold the barbell with an overhand grip, hands slightly wider than shoulder-width apart.",
            "Bend your knees and lower your hips into a squat position, keeping your back straight and chest up.",
            "Explosively extend your hips, knees, and ankles, driving the barbell upwards.",
            "As the barbell reaches chest level, pull it upwards with your arm, keeping it close to your body.",
            "Rotate your elbow under the barbell and extend your arm fully overhead, locking out your elbow.",
            "Lower the barbell back down to the starting position in a controlled manner.",
            "Repeat for the desired number of repetitions, then switch arms.",
        ],
    },
    {
        bodyPart: "shoulders",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell rear delt raise.mp4",
        id: 60,
        name: "barbell rear delt raise",
        target: "delts",
        secondaryMuscles: ["traps", "rhomboids"],
        instructions: [
            "Stand with your feet shoulder-width apart and hold a barbell with an overhand grip, palms facing down.",
            "Bend your knees slightly and hinge forward at the hips, keeping your back straight.",
            "Raise the barbell out to the sides, keeping your arms straight, until they are parallel to the ground.",
            "Pause for a moment at the top, then slowly lower the barbell back to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "shoulders",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell rear delt row.mp4",
        id: 61,
        name: "barbell rear delt row",
        target: "delts",
        secondaryMuscles: ["trapezius", "rhomboids", "biceps"],
        instructions: [
            "Stand with your feet shoulder-width apart and knees slightly bent.",
            "Hold a barbell with an overhand grip, hands slightly wider than shoulder-width apart.",
            "Bend forward at the hips, keeping your back straight and chest up.",
            "Pull the barbell towards your chest, squeezing your shoulder blades together.",
            "Pause for a moment at the top, then slowly lower the barbell back to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "shoulders",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell seated behind head military press.mp4",
        id: 62,
        name: "barbell seated behind head military press",
        target: "delts",
        secondaryMuscles: ["triceps", "upper back"],
        instructions: [
            "Sit on a bench with your back straight and feet flat on the ground.",
            "Hold the barbell with an overhand grip, slightly wider than shoulder-width apart.",
            "Lift the barbell off the rack and bring it down to shoulder level, behind your head.",
            "Press the barbell upward until your arms are fully extended.",
            "Lower the barbell back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "shoulders",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell seated bradford rocky press.mp4",
        id: 63,
        name: "barbell seated bradford rocky press",
        target: "delts",
        secondaryMuscles: ["triceps", "upper back"],
        instructions: [
            "Sit on a bench with your back straight and feet flat on the ground.",
            "Hold the barbell with an overhand grip, slightly wider than shoulder-width apart.",
            "Lift the barbell to shoulder height, keeping your elbows slightly bent and pointing forward.",
            "Press the barbell overhead, fully extending your arms.",
            "Lower the barbell back to shoulder height and repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "shoulders",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell seated overhead press.mp4",
        id: 64,
        name: "barbell seated overhead press",
        target: "delts",
        secondaryMuscles: ["triceps", "upper back"],
        instructions: [
            "Sit on a bench with your back straight and feet flat on the ground.",
            "Hold the barbell with an overhand grip, slightly wider than shoulder-width apart.",
            "Lift the barbell off the rack and bring it to shoulder level, with your elbows bent and palms facing forward.",
            "Press the barbell overhead by extending your arms fully.",
            "Pause for a moment at the top, then slowly lower the barbell back to shoulder level.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "shoulders",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell skier.mp4",
        id: 65,
        name: "barbell skier",
        target: "delts",
        secondaryMuscles: ["triceps", "core"],
        instructions: [
            "Stand with your feet shoulder-width apart and hold a barbell in front of your thighs with an overhand grip.",
            "Bend your knees slightly and hinge forward at the hips, keeping your back straight and chest up.",
            "Simultaneously lift the barbell up towards your shoulders while jumping slightly off the ground.",
            "As you reach the top of the movement, quickly reverse the motion and lower the barbell back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "shoulders",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell standing bradford press.mp4",
        id: 66,
        name: "barbell standing bradford press",
        target: "delts",
        secondaryMuscles: ["triceps", "upper back"],
        instructions: [
            "Stand with your feet shoulder-width apart and hold the barbell in front of your shoulders with an overhand grip.",
            "Press the barbell overhead, fully extending your arms.",
            "Lower the barbell back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "shoulders",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell standing front raise over head.mp4",
        id: 67,
        name: "barbell standing front raise over head",
        target: "delts",
        secondaryMuscles: ["triceps", "upper back"],
        instructions: [
            "Stand with your feet shoulder-width apart, holding a barbell in front of your thighs with an overhand grip.",
            "Keep your back straight and engage your core.",
            "Slowly raise the barbell in front of you, keeping your arms straight and your palms facing down.",
            "Continue lifting until the barbell is slightly above shoulder level.",
            "Pause for a moment at the top, then slowly lower the barbell back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper arms",
        equipment: "assisted",
        gifUrl: "./images/exercise/assisted standing triceps extension (with towel).mp4",
        id: 68,
        name: "assisted standing triceps extension (with towel)",
        target: "triceps",
        secondaryMuscles: ["shoulders"],
        instructions: [
            "Stand with your feet shoulder-width apart and hold a towel with both hands behind your head.",
            "Keep your elbows close to your ears and your upper arms stationary.",
            "Slowly extend your forearms upward, squeezing your triceps at the top.",
            "Pause for a moment, then slowly lower the towel back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper arms",
        equipment: "leverage machine",
        gifUrl: "./images/exercise/assisted triceps dip (kneeling).mp4",
        id: 69,
        name: "assisted triceps dip (kneeling)",
        target: "triceps",
        secondaryMuscles: ["chest", "shoulders"],
        instructions: [
            "Adjust the machine to your desired weight and height.",
            "Kneel down on the pad facing the machine, with your hands gripping the handles.",
            "Lower your body by bending your elbows, keeping your back straight and close to the machine.",
            "Pause for a moment at the bottom, then push yourself back up to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper arms",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell alternate biceps curl.mp4",
        id: 70,
        name: "barbell alternate biceps curl",
        target: "biceps",
        secondaryMuscles: ["forearms"],
        instructions: [
            "Stand up straight with your feet shoulder-width apart and hold a barbell in each hand, palms facing forward.",
            "Keep your upper arms stationary and exhale as you curl the weights while contracting your biceps.",
            "Continue to raise the barbells until your biceps are fully contracted and the barbells are at shoulder level.",
            "Hold the contracted position for a brief pause as you squeeze your biceps.",
            "Inhale as you slowly begin to lower the barbells back to the starting position.",
            "Repeat for the desired number of repetitions, alternating arms.",
        ],
    },
    {
        bodyPart: "upper arms",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell close-grip bench press.mp4",
        id: 71,
        name: "barbell close-grip bench press",
        target: "triceps",
        secondaryMuscles: ["chest", "shoulders"],
        instructions: [
            "Lie flat on a bench with your feet flat on the ground and your back pressed against the bench.",
            "Grasp the barbell with a close grip, slightly narrower than shoulder-width apart.",
            "Unrack the barbell and lower it slowly towards your chest, keeping your elbows close to your body.",
            "Pause for a moment when the barbell touches your chest.",
            "Push the barbell back up to the starting position, fully extending your arms.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper arms",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell curl.gif",
        id: 72,
        name: "barbell curl",
        target: "biceps",
        secondaryMuscles: ["forearms"],
        instructions: [
            "Stand up straight with your feet shoulder-width apart and hold a barbell with an underhand grip, palms facing forward.",
            "Keep your elbows close to your torso and exhale as you curl the weights while contracting your biceps.",
            "Continue to raise the bar until your biceps are fully contracted and the bar is at shoulder level.",
            "Hold the contracted position for a brief pause as you squeeze your biceps.",
            "Inhale as you slowly begin to lower the bar back to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper arms",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell decline close grip to skull press.mp4",
        id: 73,
        name: "barbell decline close grip to skull press",
        target: "triceps",
        secondaryMuscles: ["chest", "shoulders"],
        instructions: [
            "Lie on a decline bench with your head lower than your feet and hold a barbell with a close grip.",
            "Lower the barbell towards your forehead by bending your elbows, keeping your upper arms stationary.",
            "Pause for a moment, then extend your arms to press the barbell back up to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper arms",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell drag curl.gif",
        id: 74,
        name: "barbell drag curl",
        target: "biceps",
        secondaryMuscles: ["forearms"],
        instructions: [
            "Stand with your feet shoulder-width apart and hold a barbell with an underhand grip, palms facing up.",
            "Let the barbell hang at arm's length in front of your thighs.",
            "Keeping your upper arms stationary, curl the barbell up towards your chest by contracting your biceps.",
            "Pause for a moment at the top, then slowly lower the barbell back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper arms",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell incline reverse-grip press.webp",
        id: 75,
        name: "barbell incline reverse-grip press",
        target: "triceps",
        secondaryMuscles: ["chest", "shoulders"],
        instructions: [
            "Set up an incline bench at a 45-degree angle.",
            "Lie back on the bench and grasp the barbell with a reverse grip, hands slightly wider than shoulder-width apart.",
            "Unrack the barbell and lower it towards your upper chest, keeping your elbows tucked in.",
            "Pause for a moment at the bottom, then push the barbell back up to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper arms",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell jm bench press.gif",
        id: 76,
        name: "barbell jm bench press",
        target: "triceps",
        secondaryMuscles: ["chest", "shoulders"],
        instructions: [
            "Lie flat on a bench with your feet flat on the ground and your back pressed against the bench.",
            "Grasp the barbell with an overhand grip, slightly wider than shoulder-width apart.",
            "Lower the barbell to your chest, keeping your elbows tucked in close to your body.",
            "Push the barbell back up to the starting position, fully extending your arms.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper arms",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell lying close-grip press.gif",
        id: 77,
        name: "barbell lying close-grip press",
        target: "triceps",
        secondaryMuscles: ["chest", "shoulders"],
        instructions: [
            "Lie flat on a bench with your feet flat on the ground and your back pressed against the bench.",
            "Grasp the barbell with a close grip, hands shoulder-width apart, palms facing towards your feet.",
            "Lift the barbell off the rack and hold it directly above your chest with your arms fully extended.",
            "Slowly lower the barbell towards your chest, keeping your elbows close to your body.",
            "Pause for a moment when the barbell touches your chest, then push it back up to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper legs",
        equipment: "assisted",
        gifUrl: "./images/exercise/assisted prone hamstring.gif",
        id: 78,
        name: "assisted prone hamstring",
        target: "hamstrings",
        secondaryMuscles: ["glutes", "lower back"],
        instructions: [
            "Lie face down on a mat or bench with your legs fully extended.",
            "Have a partner or use a resistance band to secure your ankles.",
            "Engage your hamstrings and lift your legs towards your glutes, keeping your knees straight.",
            "Pause for a moment at the top, then slowly lower your legs back down to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper legs",
        equipment: "body weight",
        gifUrl: "./images/exercise/balance board.mp4",
        id: 79,
        name: "balance board",
        target: "quads",
        secondaryMuscles: ["calves", "hamstrings", "glutes"],
        instructions: [
            "Place the balance board on a flat surface.",
            "Step onto the balance board with one foot, ensuring it is centered.",
            "Slowly shift your weight onto the foot on the balance board, keeping your core engaged.",
            "Maintain your balance and stability as you hold the position for a desired amount of time.",
            "Repeat the exercise with the other foot.",
        ],
    },
    {
        bodyPart: "upper legs",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell bench front squat.mp4",
        id: 80,
        name: "barbell bench front squat",
        target: "quads",
        secondaryMuscles: ["hamstrings", "glutes", "calves"],
        instructions: [
            "Start by standing with your feet shoulder-width apart and the barbell resting on your upper chest, just below your collarbone.",
            "Hold the barbell with an overhand grip, keeping your elbows up and your upper arms parallel to the ground.",
            "Lower your body down into a squat position by bending at the knees and hips, keeping your back straight and your chest up.",
            "Pause for a moment at the bottom of the squat, then push through your heels to return to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper legs",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell bench squat.mp4",
        id: 81,
        name: "barbell bench squat",
        target: "quads",
        secondaryMuscles: ["glutes", "hamstrings", "calves"],
        instructions: [
            "Set up a barbell on a squat rack at chest height.",
            "Stand facing away from the rack, with your feet shoulder-width apart.",
            "Bend your knees and lower your body down into a squat position, keeping your back straight and chest up.",
            "Grasp the barbell with an overhand grip, slightly wider than shoulder-width apart.",
            "Lift the barbell off the rack and step back, ensuring your feet are still shoulder-width apart.",
            "Lower your body down into a squat, keeping your knees in line with your toes.",
            "Pause for a moment at the bottom, then push through your heels to return to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper legs",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell clean and press.mp4",
        id: 82,
        name: "barbell clean and press",
        target: "quads",
        secondaryMuscles: ["hamstrings", "glutes", "shoulders", "triceps"],
        instructions: [
            "Stand with your feet shoulder-width apart and the barbell on the floor in front of you.",
            "Bend your knees and hinge at the hips to lower down and grip the barbell with an overhand grip, hands slightly wider than shoulder-width apart.",
            "Drive through your heels and extend your hips and knees to lift the barbell off the floor, keeping it close to your body.",
            "As the barbell reaches your thighs, explosively extend your hips, shrug your shoulders, and pull the barbell up towards your chest.",
            "As the barbell reaches chest height, quickly drop under it and catch it at shoulder level, with your elbows pointing forward and your palms facing up.",
            "From the catch position, press the barbell overhead by extending your arms and pushing the barbell straight up.",
            "Lower the barbell back down to the starting position and repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper legs",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell clean-grip front squat.mp4",
        id: 83,
        name: "barbell clean-grip front squat",
        target: "glutes",
        secondaryMuscles: ["quadriceps", "hamstrings", "calves", "core"],
        instructions: [
            "Start by standing with your feet shoulder-width apart and the barbell resting on your upper chest, with your elbows pointing forward.",
            "Lower your body by bending your knees and pushing your hips back, as if you are sitting back into a chair.",
            "Keep your chest up and your back straight as you lower down, making sure your knees do not go past your toes.",
            "Continue lowering until your thighs are parallel to the ground, or as low as you can comfortably go.",
            "Pause for a moment at the bottom, then push through your heels to stand back up, extending your hips and knees.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper legs",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell deadlift.mp4",
        id: 84,
        name: "barbell deadlift",
        target: "glutes",
        secondaryMuscles: ["hamstrings", "lower back"],
        instructions: [
            "Stand with your feet shoulder-width apart and the barbell on the ground in front of you.",
            "Bend your knees and hinge at the hips to lower your torso and grip the barbell with an overhand grip, hands slightly wider than shoulder-width apart.",
            "Keep your back straight and chest lifted as you drive through your heels to lift the barbell off the ground, extending your hips and knees.",
            "As you stand up straight, squeeze your glutes and keep your core engaged.",
            "Lower the barbell back down to the ground by bending at the hips and knees, keeping your back straight.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper legs",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell front chest squat.mp4",
        id: 85,
        name: "barbell front chest squat",
        target: "glutes",
        secondaryMuscles: ["quadriceps", "hamstrings", "calves", "core"],
        instructions: [
            "Start by standing with your feet shoulder-width apart, toes slightly turned out.",
            "Hold the barbell in front of your chest with your hands shoulder-width apart, elbows pointing forward.",
            "Engage your core and keep your chest up as you lower your body down into a squat position, pushing your hips back and bending your knees.",
            "Lower until your thighs are parallel to the ground, or as low as you can comfortably go.",
            "Pause for a moment at the bottom, then push through your heels to return to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper legs",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell front squat.mp4",
        id: 86,
        name: "barbell front squat",
        target: "glutes",
        secondaryMuscles: ["quadriceps", "hamstrings", "calves", "core"],
        instructions: [
            "Start by standing with your feet shoulder-width apart, toes slightly turned out.",
            "Hold the barbell in front of your shoulders, resting it on your collarbone and shoulders.",
            "Engage your core and keep your chest up as you lower your body down into a squat position, pushing your hips back and bending your knees.",
            "Lower until your thighs are parallel to the ground, or as low as you can comfortably go.",
            "Pause for a moment at the bottom, then push through your heels to return to the starting position.",
            "Repeat for the desired number of repetitions.",
        ],
    },
    {
        bodyPart: "upper legs",
        equipment: "barbell",
        gifUrl: "./images/exercise/barbell full squat.mp4",
        id: 87,
        name: "barbell full squat",
        target: "glutes",
        secondaryMuscles: ["quadriceps", "hamstrings", "calves", "core"],
        instructions: [
            "Stand with your feet shoulder-width apart, toes slightly turned out.",
            "Hold the barbell across your upper back, resting it on your traps or rear delts.",
            "Engage your core and keep your chest up as you begin to lower your body down.",
            "Bend at the knees and hips, pushing your hips back and down as if sitting into a chair.",
            "Lower yourself until your thighs are parallel to the ground or slightly below.",
            "Keep your knees in line with your toes and your weight in your heels.",
            "Drive through your heels to stand back up, extending your hips and knees.",
            "Repeat for the desired number of repetitions.",
        ],
    },
];
export default WorkoutData;
